<template>
  <vx-card>
    <div slot="no-body" class="card-cover cursor-pointer pointer-events-auto"
         @click="handlerInfoTopicClick">
      <img :src="getCoverPhoto"
           alt="content-img" class="responsive card-img-top">
    </div>

    <h5 class="card-title mb-3">
      <feather-icon icon="InfoIcon" svgClasses="h-6 w-6 stroke-current text-success"
      class="pt-2">
      </feather-icon>
      <a class="text-dark cursor-pointer" @click="handlerInfoTopicClick">
        {{ infoTopic.topicLocal }}
      </a>
    </h5>

    <div class="flex justify-between flex-wrap center mb-3">
      <vs-chip :color="infoTopic.infoGroup.color" transparent>
        {{ infoTopic.infoGroup.nameLocal }}
      </vs-chip>
    </div>

    <p v-line-clamp="2" class="text-grey" v-html="infoTopic.descriptionLocal"></p>

    <vs-divider></vs-divider>

    <!-- READ MORE-->
    <div class="flex justify-between align-items-center">


      <small class="text-grey pt-1"> {{infoTopicDate}} </small>

      <a class="font-weight-bold text-right cursor-pointer" target="_self"
         @click="handlerInfoTopicClick">{{ $t('info-topic.read-more') }}</a>
    </div>

  </vx-card>
</template>

<script>
import {config, getPhotoUrl} from "@/utils/upload";
import moment from 'moment';
import {dateTimeFormat} from "@/utils/format";

export default {
  name: "InfoTopicCard",
  props: [
    'infoTopic'
  ],
  computed: {
    getCoverPhoto() {
      if (this.infoTopic && this.infoTopic.picturePath) {
        return getPhotoUrl(this.infoTopic.picturePath);
      }
      return `static/images/classroom-placeholder.jpeg`
    },
    infoTopicDate(){
      return moment(this.infoTopic.createdAt).format(dateTimeFormat.momentYYYYMMDD)
    }
  },
  methods: {
    handlerInfoTopicClick() {
      this.$router.push(`/info-topic-content/${this.infoTopic.id}`);
    },
    onDownloadClick(path) {
      let url = config.url.downloadFile + path;
      window.open(url, '_blank');
    },
  }
}
</script>

<style scoped>

</style>
